const STORAGE_KEY = 'pepoll_guest_token';
const PARTICIPANT_KEY = 'pepoll_guest_participant_id';
const LINK_BANNER_KEY = 'pepoll_guest_link_banner_shown';

export interface GuestSession {
  token: string | null;
  guestParticipantId: string | null;
  isActive: boolean;
  save: (token: string, guestParticipantId: string, expiresAt: string) => void;
  clear: () => void;
  markLinkBannerShown: () => void;
  hasSeenLinkBanner: () => boolean;
}

export function useGuestSession(): GuestSession {
  const token = localStorage.getItem(STORAGE_KEY);
  const guestParticipantId = localStorage.getItem(PARTICIPANT_KEY);

  const isActive = !!token && !isTokenExpired(token);

  function save(newToken: string, newGuestParticipantId: string, expiresAt: string) {
    localStorage.setItem(STORAGE_KEY, newToken);
    localStorage.setItem(PARTICIPANT_KEY, newGuestParticipantId);
    localStorage.setItem(`${STORAGE_KEY}_expires`, expiresAt);
  }

  function clear() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(PARTICIPANT_KEY);
    localStorage.removeItem(`${STORAGE_KEY}_expires`);
  }

  function markLinkBannerShown() {
    sessionStorage.setItem(LINK_BANNER_KEY, '1');
  }

  function hasSeenLinkBanner(): boolean {
    return sessionStorage.getItem(LINK_BANNER_KEY) === '1';
  }

  return { token, guestParticipantId, isActive, save, clear, markLinkBannerShown, hasSeenLinkBanner };
}

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() / 1000 > payload.exp;
  } catch {
    return true;
  }
}
